import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Loader2 } from "lucide-react";
import { useUserProfile } from "@/components/auth";

export const Route = createFileRoute("/admin")({
  component: AdminLayout,
});

function AdminLayout() {
  const { isPlatformAdmin, isPending } = useUserProfile();

  if (isPending) {
    return (
      <div className="flex items-center justify-center py-24">
        <Loader2 className="size-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!isPlatformAdmin) {
    return (
      <div className="flex items-center justify-center py-24 text-muted-foreground">
        Platform admin access required.
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <Outlet />
    </div>
  );
}
